import _ from 'lodash';
import { createReducer } from './../../common/reduxHelpers';
import * as types from './actionTypes';

export const initialState = {
    formStep: {},
    formCompleted:{}
};

const reducer = createReducer(initialState, {
    [types.CHANGE_FORM_STEP](state, action) {
        return _.assign({}, state, {
            formStep: _.assign({}, state.formStep, {
                [action.formName]: action.stepNumber
            })
        });
    },
    [types.RESET_FORM](state, action) {
       return _.assign({}, state, {
            formStep: _.assign({}, state.formStep, {
                [action.formName]: 1
            }),
            formCompleted: _.assign({}, state.formCompleted, {
                [action.formName]: false
            }),
        });
    },
    [types.CHANGE_FORM_COMPLETED_FLAG](state, action) {
        return _.assign({}, state, {
            formCompleted: _.assign({}, state.formCompleted, {
                [action.formName]: action.value
            }),
        });
    }
});

export default reducer;